import { OrderEntity, OrderMissionEntity } from '@src/features/order/entities';

// A finished delivery arrives as a mission wrapper with the order nested under `orders[0]`,
// and the flight plan (route geometry, altitude mode, takeoff) lives on the wrapper rather
// than on that nested order. Repeating only the nested order therefore throws away the whole
// plan, which is exactly what Repeat is meant to bring back — so merge both levels, keeping
// the nested value whenever it has one.
export const toRepeatedOrder = (source: OrderMissionEntity | OrderEntity): OrderEntity => {
  const mission = source as Record<string, any>;
  const nested = (Array.isArray(mission.orders) && mission.orders.length ? mission.orders[0] : mission) as OrderEntity;

  return {
    ...nested,
    missionId: nested.missionId ?? mission.missionId,
    altitudeMode: nested.altitudeMode ?? mission.altitudeMode,
    takeoffLocation: nested.takeoffLocation ?? mission.takeoffLocation,
    deliveryMode: nested.deliveryMode || mission.deliveryMode,
    waypoints: nested.waypoints?.length ? nested.waypoints : mission.waypoints,
  };
};
